import {useEffect, useState} from "react";

export default function useRerenders(interval) {
  let [t, setT] = useState(undefined);

  useEffect(() => {
    let timer = setInterval(() => {
      setT(Math.random());
    }, interval);

    return () => clearInterval(timer);
  }, []);

  return null;
}